import { colors } from '@styles/vars/colors.style'
import { clamp } from '@styles/utils/conversion.style'
import { font } from '@styles/vars/font.style'
import { mq } from '@styles/vars/media-queries.style'
import styled from 'styled-components'

export const SideBySideMain = styled.section`
  background-color: ${props => props.bgColor ? props.bgColor : colors.charcoal};
  color: ${props => props.tColor ? props.tColor : colors.white};
  .imageCol {
    text-align: end;
    ${mq.tabletL} {
      padding-left: 30px;
    }
  }
  .content {
    p {
      ${clamp('font-size', 16, 27)};
      font-family: ${font.serif.family};
    }
    ul {
      list-style: disc;
      padding-left: 30px;
    }
  }
`

